import { zodResolver } from "@hookform/resolvers/zod";
import Button from "../../../../../../../../library/button";
import { getIcon } from "../../../../../../../../utils/get-icon";
import { schema, UpdateNameSchema } from "./schema";
import { ButtonsWrapper, Field, Form } from "./styled";
import { useForm } from "react-hook-form";
import { Label } from "../../../../../../../../library/label";
import Input from "../../../../../../../../library/input";
import useUpdateUser from "../../../../../../../../hooks/useUpdateUser";

interface Props {
  firstName?: string;
  lastName?: string;
  onClose: () => void;
  onSuccess: () => void;
  onError: () => void;
}

const EditModal = ({
  firstName,
  lastName,
  onClose,
  onSuccess,
  onError,
}: Props) => {
  const { updateUserName } = useUpdateUser();

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm<UpdateNameSchema>({
    resolver: zodResolver(schema),
    defaultValues: {
      firstName,
      lastName,
    },
  });

  const updateName = async (data: UpdateNameSchema) => {
    try {
      const update = await updateUserName(data);
      if (update?.error === null) {
        onSuccess();
      } else {
        throw update.error;
      }
    } catch (e) {
      onError();
    }
  };

  return (
    <Form onSubmit={handleSubmit(updateName)}>
      <Field>
        <Label htmlFor="firstName">Fornavn</Label>
        <Input
          register={register}
          name="firstName"
          variant="regular"
          placeholder="Fornavn"
          error={errors["firstName"]}
        />
      </Field>
      <Field>
        <Label htmlFor="lastName">Etternavn</Label>
        <Input
          register={register}
          name="lastName"
          variant="regular"
          placeholder="Etternavn"
          error={errors["lastName"]}
        />
      </Field>
      <ButtonsWrapper>
        <Button
          onClick={onClose}
          color="grey"
          variant="regular"
          spacing="right"
        >
          Avbryt
        </Button>
        <Button
          disabled={isSubmitting}
          type="submit"
          color="blue"
          variant="regular"
        >
          {isSubmitting ? (
            <>{getIcon("spinner")} Oppdaterer..</>
          ) : (
            <>Endre navn</>
          )}
        </Button>
      </ButtonsWrapper>
    </Form>
  );
};

export default EditModal;
